// Mesure des conversions par délégation de clic : un seul écouteur pour toutes les pages publiques.
// - Les conteneurs marqués data-track-zone="hero|band|quote|contact_card|bar" émettent « CTA: Navigation »
//   avec cta = « <zone>_<cible> » (même évènement et même propriété que l'en-tête et le pied de page).
// - Les liens tel:/mailto: émettent « Contact: Click » ; les liens avec l'attribut download émettent « File Download ».
// Voir docs/mesure-plausible.md pour la liste des objectifs à créer dans Plausible.
export default defineNuxtPlugin((nuxtApp) => {
  const trackingKey = (link: HTMLElement): string => {
    const explicit = link.dataset.trackKey
    if (explicit) {
      return explicit
    }
    const href = link.getAttribute('href') || ''
    if (href.startsWith('/')) {
      return href.slice(1).split(/[/?#]/)[0] || 'accueil'
    }
    if (href.startsWith('tel:')) {
      return 'telephone'
    }
    if (href.startsWith('mailto:')) {
      return 'email'
    }
    if (href.startsWith('#')) {
      return 'ancre'
    }
    return href ? 'externe' : 'bouton'
  }

  document.addEventListener('click', (event) => {
    const target = event.target
    if (!(target instanceof Element)) {
      return
    }
    const link = target.closest<HTMLElement>('a, button')
    if (!link) {
      return
    }

    nuxtApp.runWithContext(() => {
      const zone = link.closest<HTMLElement>('[data-track-zone]')?.dataset.trackZone
      if (zone) {
        useTrackEvent('CTA: Navigation', { props: { cta: `${zone}_${trackingKey(link)}` } })
      }

      const href = link.getAttribute('href') || ''
      if (href.startsWith('tel:') || href.startsWith('mailto:')) {
        useTrackEvent('Contact: Click', { props: { type: href.startsWith('tel:') ? 'telephone' : 'email' } })
      }
      if (link.hasAttribute('download')) {
        useTrackEvent('File Download', { props: { url: href } })
      }
    })
  })
})
